import { Text } from '../text/Text.tsx'
import { Button } from '../button/Button.tsx'
import { StatusPage } from './StatusPage.tsx'
import styles from './StatusPage.module.css'

export interface ErrorPageProps {
  title?: string
  message?: string
  onRetry?: () => void
  onGoHome?: () => void
}

export function ErrorPage({
  title = 'Critical Hit',
  message = "Something broke. Our team has been notified — they're patching it now.",
  onRetry,
  onGoHome,
}: ErrorPageProps) {
  return (
    <StatusPage>
      <div className={styles.glitch} data-text="ERR">ERR</div>
      <Text as="h1" size="xl" weight="bold" className={styles.title}>
        {title}
      </Text>
      <Text as="p" size="sm" muted className={styles.subtitle}>
        {message}
      </Text>
      <div className={styles.actions}>
        {onRetry && (
          <Button variant="primary" size="sm" onClick={onRetry}>
            Try Again
          </Button>
        )}
        {onGoHome && (
          <Button variant="ghost" size="sm" onClick={onGoHome}>
            Return to Base
          </Button>
        )}
      </div>
      <Text as="p" size="xs" muted className={styles.hint}>
        If this keeps happening, try a hard refresh.
      </Text>
    </StatusPage>
  )
}
